import { UserModel } from '@admin/modules/users/models/user.model';

export const mapApiResponseToUserModels = (response: any, tenantId: string): UserModel => {
    return {
        ...response,
        collectors: response.collectors?.filter((c: any) => c.tenantId === tenantId) ?? [],
        permissions: response.extraPermissions.length > 0 //TODO: check possible permissions
    };
};
